/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetAIEvaluationRunPathParams = NonNullable<operations['getAIEvaluationRun']['parameters']['path']>;

export interface Input extends GetAIEvaluationRunPathParams {
  apiVersion?: string;
  header: NonNullable<operations['getAIEvaluationRun']['parameters']['header']>;
}

export async function getAIEvaluationRun(
  { apiVersion, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projectKey}/ai/evaluations/{evaluationId}/runs/{runId}', {
    params: { path, header },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
